import { FormGroup, FormParagraph } from '@ksyos/design-system';
import type { IOrganizationGeneralSettings } from '@common/validation/organization';
import { OrganizationStructureType } from '@common/enums';
import { EnumSelect } from '@frontend/components/fields/EnumSelect';
import { getSelectedLanguage } from '@frontend/translate';

type IOrganizationStructureTypeFormGroupProps = {
    canEdit: boolean;
    onChange: <Key extends keyof IOrganizationGeneralSettings>(
        key: Key,
        value: IOrganizationGeneralSettings[Key]
    ) => void;
    organizationStructureType: OrganizationStructureType;
};

export function OrganizationStructureTypeFormGroup({
    canEdit,
    onChange,
    organizationStructureType,
}: Readonly<IOrganizationStructureTypeFormGroupProps>) {
    const translate = getSelectedLanguage();

    return (
        <FormGroup
            isRequired={canEdit}
            label={translate.organization.organizationStructureType}
        >
            {!canEdit && (
                <FormParagraph>{translate.organizationStructureTypeEnum[organizationStructureType]}</FormParagraph>
            )}
            {canEdit && (
                <EnumSelect
                    enumObj={OrganizationStructureType}
                    isClearable={false}
                    isMulti={false}
                    labels={translate.organizationStructureTypeEnum}
                    onChange={(item) => {
                        if (item?.value) {
                            onChange('organizationStructureType', item.value);
                        }
                    }}
                    value={organizationStructureType}
                />
            )}
        </FormGroup>
    );
}
